/*Copyright (c) 2023. Honeywell International, Inc. All rights reserved.
This file contains trade secrets of Honeywell International, Inc. 
No part may be reproduced or transmitted in any form by any means or for anypurpose without the express written permission of Honeywell. */

import { useEffect, useState } from "react";
import DialogForError from "../../components/SharedComponents/DialogForError";
import { IErrorProps } from "../../models";

function ErrorPage() {
  const [openDialogNoURLError, setOpenDialogNoURLError] = useState(false);
  const onDialogForNOURLCloseHandler = () => setOpenDialogNoURLError(true);
  const [errorList, setErrorList] = useState<Array<IErrorProps>>([]);

  useEffect(() => {
    setOpenDialogNoURLError(true);
    setErrorList([]);
    const error: IErrorProps = {
      errorCode: 401,
      errorMessage:
        "You don't have access to the UDP admin portal. Please contact your administrator.",
    };
    // istanbul ignore next
    // errorList is 0
    if (errorList.length > 0) {
      errorList.forEach((errorDetails) => {
        if (errorDetails.errorMessage != error.errorMessage) {
          errorList.push(error);
        }
      });
    } else {
      errorList.push(error);
    }
    setErrorList(errorList);
  }, []);

  return (
    <DialogForError
      open={openDialogNoURLError}
      onClose={onDialogForNOURLCloseHandler}
      errorList={errorList}
      errorType="noAccessError"
    />
  );
}
export default ErrorPage;
